import React from 'react';
import PropTypes from 'prop-types';
import { invoiceReceiptDateTime } from 'utils/formatter';
import styles from './InfoBox.css';

class ReceiptRefundInfo extends React.Component {
  render() {
    const { invoiceDetail, invoiceRefund } = this.props;
    return (
      <div className={styles['receipt-info-box']}>
        <div className={styles['receipt-date']}>
          <div className="pull-left">
            {invoiceReceiptDateTime(invoiceRefund.created_at, 'date')}
          </div>
          <div className="pull-right">
            {invoiceReceiptDateTime(invoiceRefund.created_at, 'time')}
          </div>
        </div>

        <div className={styles['receipt-number']}>
          <div className="pull-left">Invoice Number</div>
          <div className="pull-right">{invoiceDetail.invoice_no}</div>
        </div>

        {invoiceDetail.table_name && (
          <div className={styles['receipt-number']}>
            <div className="pull-left">Table Name</div>
            <div className="pull-right">{invoiceDetail.table_name}</div>
          </div>
        )}

        <div className={styles['receipt-collected']}>
          <div className="pull-left">Cancelled By</div>
          <div className="pull-right">{invoiceRefund.refunded_by}</div>
        </div>

        {(invoiceDetail.customer_name || invoiceDetail.customer_email) && (
          <div className={styles['receipt-served']}>
            <div className="pull-left">Customer</div>
            <div className="pull-right">
              {invoiceDetail.customer_name || invoiceDetail.customer_email}
            </div>
          </div>
        )}
      </div>
    );
  }
}

ReceiptRefundInfo.propTypes = {
  invoiceDetail: PropTypes.object,
  invoiceRefund: PropTypes.object,
};

export default ReceiptRefundInfo;
